import { ref } from 'vue';
import { useDataStore } from '@/js/stores/DataStore.js';

const MODAL_HEIGHT_KEY = 'app.modalheight';
const OVERLAY_Z_INDEX_STEP = 2;
let fallbackZIndex = 5000;

export function useOverlayZIndex(minimumZIndex: number | null = null) {
    const activeZIndex = ref<number | null>(null);

    const allocateZIndex = () => {
        const store = useDataStore();
        const currentZIndex = minimumZIndex ? minimumZIndex : Number(store.get(MODAL_HEIGHT_KEY, fallbackZIndex));
        const nextZIndex = Math.max(currentZIndex + OVERLAY_Z_INDEX_STEP, minimumZIndex ?? 0);
        if (typeof store.set === 'function') {
            store.set(MODAL_HEIGHT_KEY, nextZIndex);
        } else {
            fallbackZIndex = nextZIndex;
        }

        activeZIndex.value = nextZIndex;

        return nextZIndex;
    };
    return {
        activeZIndex,
        allocateZIndex,
    };
}
